module.exports = __webpack_public_path__ + "img/WorstIcon.f41d2389.svg";